import { l } from '@ds/index'

import { BillingCurrency } from 'common/billing/constants/BillingCurrency'
import { PricePeriod } from 'common/billing/constants/PricePeriod'

export const calculateAnnualSavings = ({
  currentPlanPrice,
  targetPlanPrice,
  targetPlanPeriod,
  currency,
}: {
  currentPlanPrice: number
  targetPlanPrice: number
  targetPlanPeriod: PricePeriod | undefined
  currency: BillingCurrency
}) => {
  let offerPlanPrice = 0
  if (targetPlanPeriod === PricePeriod.MONTHLY) {
    offerPlanPrice = targetPlanPrice * 12
  } else if (targetPlanPeriod === PricePeriod.YEARLY) {
    offerPlanPrice = targetPlanPrice
  }
  return {
    amount: currentPlanPrice * 12 - offerPlanPrice,
    currency,
  }
}

export const getHeaderAndSubheader = ({ isPriceDown }: { isPriceDown: boolean }) => {
  if (isPriceDown) {
    return {
      header: l.makeTranslate('Good news before you keep going: you could be paying less'),
      subheader: l.makeTranslate(
        "Our new plans charge for Active Contacts, the people you reach each month, not everyone sitting in your account. That's why yours can cost less.",
      ),
    }
  }

  return {
    header: l.makeTranslate('Good news before you keep going: your plan now <br/> covers more'),
  }
}
